<script setup>
import {computed} from 'vue';
import {ExclamationCircleIcon, CheckCircleIcon} from '@heroicons/vue/24/solid';

const {level} = defineProps({
    message: String,
    level: {
        type: String,
        default: 'success',
    },
});

const background = computed(() => {
    const classes = {
        success: 'bg-green-500',
        error: 'bg-red-500',
    };
    return classes[level];
});

const icon = computed(() => {
    if (level === 'success') {
        return CheckCircleIcon;
    }
    if (level === 'error') {
        return ExclamationCircleIcon;
    }
});
</script>

<template>
    <div class="flex items-center px-3 py-2 text-white rounded" :class="background">
        <component :is="icon" class="size-6 mr-2"/>
        {{ message }}
    </div>
</template>
